var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wallet-stat" },
    [
      _c("custom-breadcrumb"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stat-area-main" },
        [
          _c("div", { staticClass: "content" }, [
            _c("span", { staticClass: "stat-title" }, [
              _vm._v("Available Balance")
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "format",
                    rawName: "v-format",
                    value: "$#,##0.00",
                    expression: "'$#,##0.00'"
                  }
                ],
                staticClass: "stat-content"
              },
              [_vm._v(_vm._s(_vm.availableBalance))]
            )
          ]),
          _vm._v(" "),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", { staticClass: "stat-title" }, [
              _vm._v("Total Revenue")
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "format",
                    rawName: "v-format",
                    value: "$#,##0.00",
                    expression: "'$#,##0.00'"
                  }
                ],
                staticClass: "stat-content"
              },
              [_vm._v(_vm._s(_vm.totalRevenue))]
            )
          ]),
          _vm._v(" "),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", { staticClass: "stat-title" }, [_vm._v("Received")]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "format",
                    rawName: "v-format",
                    value: "$#,##0.00",
                    expression: "'$#,##0.00'"
                  }
                ],
                staticClass: "stat-content"
              },
              [_vm._v(_vm._s(_vm.received))]
            )
          ]),
          _vm._v(" "),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", { staticClass: "stat-title" }, [_vm._v("Pending")]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "format",
                    rawName: "v-format",
                    value: "$#,##0.00",
                    expression: "'$#,##0.00'"
                  }
                ],
                staticClass: "stat-content"
              },
              [_vm._v(_vm._s(_vm.pending))]
            )
          ]),
          _vm._v(" "),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("span", { staticClass: "stat-title" }, [_vm._v("Earned")]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "format",
                    rawName: "v-format",
                    value: "$#,##0.00",
                    expression: "'$#,##0.00'"
                  }
                ],
                staticClass: "stat-content"
              },
              [_vm._v(_vm._s(_vm.withdrawn))]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0db4c1f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db4c1f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wallet/stat-info.vue
// module id = ghne
// module chunks = 2